import styled from 'styled-components'

export default styled.div`
  display: block;
  position: relative;
  height: 294px;
  width: 100%;
`
